import * as React from 'react'
import get from 'lodash/get'
import min from 'lodash/min'
import { FormAction, FormErrors, reduxForm, stopSubmit } from 'redux-form'
import { connect } from 'react-redux'
import Scroll from 'react-scroll'
import { compose } from 'recompose'

import { ReduxState } from '../../types/redux'
import { formValidationActions } from '../../redux'
import * as Helpers from '../../utils/helpers'

const scroll = Scroll.animateScroll

export const onSubmitFail = (errors: Object) => {
  const errorNames = Helpers.getSubmitErrorNames(errors)
  if (!errorNames) {
    return
  }
  const errorElements = errorNames.map(name => document.getElementsByName(name)[0])
  const errorOffsets = errorElements.map(element => {
    if (element) {
      const rec = element.getBoundingClientRect()
      return rec && rec.top + window.scrollY
    }
    return null
  })
  const topElementOffset = min(errorOffsets)

  scroll.scrollTo(topElementOffset, { duration: 500 })
}

export interface FormInterface {
  change: (field: string, value: any) => void
  errors: object
  fields: object
  handleSubmit: (onSubmit: any) => () => void
  initialize: (data: any) => void
  initialValues: Partial<FormData>
  invalid: boolean
  untouch: any
  payloadProps: object
  serverErrors: object
  setErrors: (form: string, errors?: FormErrors<any, any>) => FormAction
  validateOnServer: (values: any, url: string, resolve: Function, reject: Function) => object
  values: { [key: string]: any }
}

export interface WizardInterface {
  wizard: {
    gotoNext: any
    gotoPrevious: any
  }
}

interface DecoratorConfig {
  dataKey?: any
  // submitValidationUrl?: any;
  // submitValidationFormatting?: any;
  // onSubmitFail?: any;
  destroyOnUnmount?: any
  noScrollToError?: any
  name: string
  validate?: any
  initialValues?: any
  mapStateToPayloadProps?: any
}

const decorator = (config: DecoratorConfig) => (ComposedComponent: any) => {
  class Form extends React.Component<FormInterface> {
    componentDidMount() {
      this.handleFormInitialize(get(this.props, config.dataKey))
    }

    componentDidUpdate(prevProps: FormInterface) {
      if (get(this.props, config.dataKey) !== get(prevProps, config.dataKey)) {
        this.handleFormInitialize(get(this.props, config.dataKey))
      }
    }

    handleFormInitialize = (data: Object) => {
      const { initialize, initialValues } = this.props

      if (config.dataKey) {
        initialize({
          ...initialValues,
          ...data,
        })
      }
    }

    handleSubmit = (onSubmit: any) => () => {
      const { handleSubmit } = this.props

      // if (config.submitValidationUrl) {
      //   handleSubmit((...props) => this.validate(onSubmit, ...props))();
      // } else {
      handleSubmit(onSubmit)()
      // }
    }

    render() {
      return (
        <div>
          <ComposedComponent {...this.props} handleSubmit={this.handleSubmit} />
        </div>
      )
    }
  }

  return compose(
    reduxForm({
      ...config,
      form: config.name, // Remapping form name from attribute "name" to attribute "form"
      destroyOnUnmount: config.destroyOnUnmount || false,
    }),
    connect(
      (state: ReduxState): any => ({
        values: state.form[config.name] && state.form[config.name].values,
        errors: state.form[config.name] && state.form[config.name].syncErrors,
        serverErrors:
          state.form[config.name] && (state.form[config.name].submitErrors || { helpers: {} }),
        fields: state.form[config.name] && state.form[config.name].fields,
      }),
      {
        validateOnServer: formValidationActions.validateFields,
        setErrors: stopSubmit,
      }
    )
  )(Form)
}

export default decorator
